import { Grid } from '@mantine/core';
import type { UseFormReturn } from 'react-hook-form';
import { Show } from '../../../../../../../react-commons/components/control-flow/Show';
import type { FormNames } from '../../../../../../../react-commons/utils/form/getFormNames';
import { ResourceType } from '../../../../../resource/enumerations/ResourceType';
import {
    UseCasePropertyValidation,
    type UseCaseResource,
} from '../../../../../resource/resources/artifacts/use_case/useCaseResource';
import { PropertyInputs } from '../../../../reusable-components/base/property-bases/PropertyInputs';
import type { PropertyValidationInformation } from '../../../../util/PropertyValidationInformation';

export const UseCaseContent = ({
    id,
    form,
    formNames,
    readOnly,
    displayedInOverview,
}: {
    id?: string;
    form: UseFormReturn<UseCaseResource>;
    formNames: FormNames<UseCaseResource>;
    readOnly: boolean;
    displayedInOverview?: boolean;
}) => {
    const getPropertyValidationInformation = (
        propertyIdentifier: UseCasePropertyValidation
    ): PropertyValidationInformation => ({
        resourceId: id,
        resourceType: ResourceType.USE_CASE,
        propertyIdentifier,
    });

    return (
        <Grid>
            <Show when={!displayedInOverview}>
                <Grid.Col span={12}>
                    <PropertyInputs.Name
                        name={formNames.name}
                        control={form.control}
                        readOnly={readOnly}
                        propertyValidationInformation={getPropertyValidationInformation(UseCasePropertyValidation.NAME)}
                    />
                </Grid.Col>
            </Show>
            <Grid.Col span={12}>
                <PropertyInputs.MultilineString
                    name={formNames.description}
                    nullable={false}
                    control={form.control}
                    readOnly={readOnly}
                    propertyValidationInformation={getPropertyValidationInformation(
                        UseCasePropertyValidation.DESCRIPTION
                    )}
                />
            </Grid.Col>
        </Grid>
    );
};
